global.Cookies = require('js-cookie/src/js.cookie');